import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { CTABanner } from '../components/CTABanner';
const allTestimonials = [{
  quote: "The level of compassion and professionalism from the Crownehealth team is unmatched. They didn't just care for my mother; they brought joy back into her daily routine. The caregivers feel like an extension of our own family.",
  author: 'Sarah Jenkins',
  relationship: 'Daughter of Patient',
  rating: 5
}, {
  quote: 'After my surgery, the in-home therapy team was incredible. They were patient, encouraging, and tailored every session to my pace. I recovered faster than expected and felt supported every step of the way.',
  author: 'Robert Chen',
  relationship: 'Rehabilitation Patient',
  rating: 5
}, {
  quote: 'Finding trustworthy care was overwhelming until we found Crownehealth. Their transparent communication and genuine warmth gave our family complete peace of mind during a very difficult transition.',
  author: 'Elena Rodriguez',
  relationship: 'Family Caregiver',
  rating: 5
}, {
  quote: 'The specialized nursing care my husband received was exceptional. The nurses were not only highly skilled but also took the time to explain everything to us, making sure we felt comfortable and informed.',
  author: 'Margaret Thompson',
  relationship: 'Wife of Patient',
  rating: 5
}, {
  quote: "Crownehealth's wellness programs have been a game-changer for my father. The cognitive stimulation activities and social engagement have noticeably improved his mood and overall outlook on life.",
  author: 'David Miller',
  relationship: 'Son of Patient',
  rating: 4
}, {
  quote: 'I cannot recommend Crownehealth enough. From the initial consultation to the daily care, every interaction has been marked by respect, dignity, and a true commitment to excellence.',
  author: 'Linda Davis',
  relationship: 'Former Patient',
  rating: 5
}];
export function TestimonialsPage() {
  return <div className="bg-nude-light min-h-screen" data-id="element-367">
      <PageHeader title="Stories from Our Families" subtitle="Read about the real experiences of those who have entrusted us with their care." data-id="element-368" />

      {/* Featured Testimonial */}
      <section className="py-20" data-id="element-369">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-370">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-nude rounded-[3rem] p-10 md:p-16 relative overflow-hidden shadow-soft-lg" data-id="element-371">
            <Quote className="absolute top-10 left-10 text-white/40" size={80} data-id="element-372" />
            <div className="relative z-10 text-center" data-id="element-373">
              <div className="flex justify-center gap-1 mb-8" data-id="element-374">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-8 h-8 text-gold fill-current" data-id="element-375" />)}
              </div>
              <p className="text-2xl md:text-3xl font-serif text-chocolate leading-relaxed mb-10" data-id="element-376">
                "Crownehealth didn't just provide medical care; they provided a
                lifeline for our family. Their team's dedication to preserving
                my father's dignity while managing his complex needs was nothing
                short of miraculous. They are truly a different kind of care
                provider."
              </p>
              <div data-id="element-377">
                <div className="font-bold text-xl text-chocolate mb-1" data-id="element-378">
                  James Wilson
                </div>
                <div className="text-chocolate/70" data-id="element-379">
                  Son of Long-term Care Patient
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-10 pb-24" data-id="element-380">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-381">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-382">
            {allTestimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-white rounded-3xl p-8 shadow-soft flex flex-col h-full" data-id="element-383">
                <div className="flex gap-1 mb-6" data-id="element-384">
                  {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-current" data-id="element-385" />)}
                </div>
                <p className="text-chocolate/80 text-lg leading-relaxed mb-8 flex-grow" data-id="element-386">
                  "{testimonial.quote}"
                </p>
                <div className="mt-auto pt-6 border-t border-nude/30" data-id="element-387">
                  <div className="font-serif font-bold text-chocolate text-lg" data-id="element-388">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-chocolate/60" data-id="element-389">
                    {testimonial.relationship}
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Share Your Story CTA */}
      <section className="py-20 bg-white" data-id="element-390">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-391">
          <h2 className="text-3xl md:text-4xl font-serif text-chocolate mb-6" data-id="element-392">
            Have a Story to Share?
          </h2>
          <p className="text-lg text-chocolate/80 mb-10" data-id="element-393">
            We love hearing from our patients and their families. Your feedback
            helps us continue to provide the highest standard of care and
            inspires our team every day.
          </p>
          <button className="bg-chocolate text-cream px-8 py-4 rounded-full font-bold text-lg hover:bg-gold hover:text-white transition-colors shadow-md" data-id="element-394">
            Submit Your Testimonial
          </button>
        </div>
      </section>

      <CTABanner data-id="element-395" />
    </div>;
}